var map = {
	"./Digital_1.jpg": 6119,
	"./Digital_2.jpg": 9624,
	"./Digital_3.jpg": 4453,
	"./Digital_4.jpg": 7390,
	"./Digital_section.jpg": 3031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8891;